"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSortApi = updateSortApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 修改排序
 */
function updateSortApi(params) {
  // return request({
  //   url: `/admin/store/product/updateSort/${params.id}/${params.sort}`,
  //   method: 'GET',
  // });

  return requestMapi({
    url: "/mapi/product/store/product/updateSort/".concat(params.id, "/").concat(params.sort),
    method: 'get'
  });
}